import SectionHeading from '../components/SectionHeading';
import RoomCard from '../components/RoomCard';
import BookingPrompt from '../components/BookingPrompt';
import { useSiteContent } from '../context/SiteContent';

export default function Rooms() {
  const { site } = useSiteContent();
  return (
    <main>
      <section className="page-hero page-hero-rooms"><div className="page-width"><span className="eyebrow">Find your space</span><h1>Our Rooms</h1><p>Four welcoming rooms, ready for a stay at your own pace.</p></div></section>
      <section className="section-pad section-cream"><div className="page-width">
        <SectionHeading eyebrow="A comfortable place to land" title="Choose Your Room" description="Room descriptions, prices and details are placeholders until confirmed by the guest house." />
        <div className="rooms-grid">{site.rooms.map((room) => <RoomCard room={room} key={room.number} />)}</div>
      </div></section>
      <section className="section-pad page-width"><BookingPrompt /></section>
    </main>
  );
}